// Block-recording mode prompts.
//
// "Block" mode lets the actor record several adjacent cues in a single
// continuous take, which is faster and gives a more natural cadence. The
// system suggests block mode when it detects a pattern (close-spaced cues,
// same scene, effort/action). Each prompt offers a one-key shortcut.
/** Suggest grouping N close-spaced cues (default trigger: gap < 2 s, N >= 2). */
export function autoClusterOffer(cueCount) {
    return {
        icon: '🧩',
        zh: `下面 ${cueCount} 条间隔很短,要一起录吗?(B)`,
        en: `These ${cueCount} cues are close together — record as one block? (B)`,
        es: `Estas ${cueCount} tomas están muy cerca — ¿grabarlas como un bloque? (B)`,
    };
}
/** Suggest recording a whole scene end-to-end. Uses the scene's display label. */
export function sceneBlockOffer(sceneLabel) {
    return {
        icon: '🎬',
        zh: `录整场 ${sceneLabel}(G)`,
        en: `Record full ${sceneLabel} (G)`,
        es: `Grabar la escena completa ${sceneLabel} (G)`,
    };
}
/**
 * Range block: actor highlights cues N to M and we offer to record them
 * continuously. Used when the auto-clusterer didn't catch the grouping.
 */
export function rangeBlockOffer(from, to) {
    const count = to - from + 1;
    return {
        icon: '🎯',
        zh: `选中 ${count} 条(${from}-${to}),按一次连录?(L)`,
        en: `Record the selected ${count} cues (${from}-${to}) in one pass? (L)`,
        es: `¿Grabar las ${count} tomas seleccionadas (${from}-${to}) de una sola pasada? (L)`,
    };
}
/**
 * Effort/action scene: combat cries, breath work, exertion. These benefit
 * from being delivered as a continuous performance instead of cue-by-cue.
 */
export const EFFORT_OFFER = {
    icon: '💥',
    zh: '本场是 effort/打斗。整段录一气呵成?(E)',
    en: 'This scene is effort/action — record continuously? (E)',
    es: 'Esta escena es de esfuerzo/acción — ¿grabarla del tirón? (E)',
};
/** Confirmation banner shown once block recording is armed. */
export function blockArmed(cueCount) {
    return {
        icon: '🟢',
        zh: `连录已就绪 · ${cueCount} 条 · 按 Space 开始`,
        en: `Block ready · ${cueCount} cues · press Space to start`,
        es: `Bloque listo · ${cueCount} tomas · pulse Espacio para empezar`,
    };
}
/** Banner shown after block recording is split back into per-cue takes. */
export const BLOCK_SPLIT_DONE = {
    icon: '✂️',
    zh: '连录已切分回每条独立 take。可逐条听审。',
    en: 'Block split back into individual takes. Review them one by one.',
    es: 'El bloque se dividió de nuevo en tomas individuales. Revíselas una por una.',
};
